module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "container-fluid map-bg",
    class: mapClass
  }, [_h('div', {
    staticClass: "row"
  }, [_h('div', {
    staticClass: "col-sm-6 col-sm-offset-3 col-lg-4 col-lg-offset-4 inner-container"
  }, [_h('div', {
    staticClass: "mapping noselect pointer"
  }, [_h('h1', {
    attrs: {
      "id": "map"
    }
  }, [_s(mapName)])]), " ", _h('div', {
    staticClass: "player-list"
  }, [_h('h5', {
    staticClass: "heading"
  }, ["\n          Lobby\n          ", _h('span', {
    staticClass: "pull-right",
    attrs: {
      "id": "span_player_in_lobby"
    }
  }, ["\n            " + _s(totalPlayerInLobbyText) + "\n          "])]), " ", _h('ul', {
    staticClass: "list-group",
    attrs: {
      "id": "ul_lobby_room"
    }
  }, [_l((playerInLobby), function(player, index) {
    return _h('li', {
      staticClass: "list-group-item player",
      class: lobbyAttrs[index].class,
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) return;
          movePlayerToPending(player)
        }
      }
    }, ["\n            " + _s($store.state.player.list[player].name) + "\n            ", ($store.state.player.list[player].name === luckyPlayer) ? _h('span', {
      staticClass: "glyphicon glyphicon-star",
      attrs: {
        "style": "margin-left: 5px; color:orange; text-shadow:none;",
        "title": "You are lucky player!"
      }
    }) : _e()])
  })]), " ", _h('h5', {
    staticClass: "heading"
  }, ["Players\n\n          ", _h('span', {
    staticClass: "pull-right",
    attrs: {
      "id": "span_player_in_lobby"
    }
  }, ["\n            " + _s(totalPlayerInPendingText) + "\n          "])]), " ", _h('ul', {
    staticClass: "list-group",
    attrs: {
      "id": "ul_pending",
      "style": "margin-bottom: 0px;"
    }
  }, [_l((playerInPending), function(player) {
    return _h('li', {
      directives: [{
        name: "touch",
        rawName: "v-touch:press",
        value: (deletePlayer),
        expression: "deletePlayer",
        arg: "press"
      }],
      staticClass: "list-group-item player",
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) return;
          movePlayerToLobby(player)
        }
      }
    }, [_s($store.state.player.list[player].name)])
  })]), " ", _h('ul', {
    staticClass: "list-group"
  }, [(!showAddPlayer) ? _h('li', {
    staticClass: "list-group-item add-player",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) return;
        openAddPlayer($event)
      }
    }
  }, ["\n            Add Player ...\n          "]) : _e(), " ", (showAddPlayer) ? _h('li', {
    staticClass: "list-group-item add-player-form"
  }, [_h('div', {
    staticClass: "input-group"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (newPlayer),
      expression: "newPlayer"
    }],
    ref: "addPlayerInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Player Name"
    },
    domProps: {
      "value": _s(newPlayer)
    },
    on: {
      "keydown": function($event) {
        if ($event.keyCode !== 13) return;
        addPlayer($event)
      },
      "input": function($event) {
        if ($event.target.composing) return;
        newPlayer = $event.target.value
      }
    }
  }), " ", _h('div', {
    staticClass: "input-group-btn"
  }, [_h('button', {
    staticClass: "btn btn-default",
    on: {
      "click": addPlayer
    }
  }, [(this.newPlayer) ? _h('span', ["Add"]) : _e(), " ", (!this.newPlayer) ? _h('span', ["Close"]) : _e()])])])]) : _e()]), " ", _h('button', {
    staticClass: "btn btn-primary btn-block btn-lg",
    attrs: {
      "id": "shuffle",
      "disabled": $store.state.room.lobby.length < 1
    },
    on: {
      "click": shuffle
    }
  }, ["\n          Shuffle\n        "]), " ", _h('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "swap_to_bot",
      "disabled": $store.state.player.hasBot === false
    },
    on: {
      "click": swapWithBot
    }
  }, ["\n          Swap AI Player\n        "]), " ", _m(0)]), " ", _h('div', {
    staticClass: "row"
  }, [_h('div', {
    staticClass: "col-sm-6"
  }, [_h('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "reset",
      "disabled": $store.state.room.lobby.length < 1
    },
    on: {
      "click": kickAllFromLobby
    }
  }, ["Clear Lobby"])]), " ", _h('div', {
    staticClass: "col-sm-6"
  }, [_h('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": shuffleMap
    }
  }, ["Random Battleground"])])])]), " "]), " ", " ", _h('div', {
    attrs: {
      "style": "width:1px;height: 1px;overflow: hidden;opacity: 0;",
      "id": "preloader"
    }
  }, [_m(1), " ", _l((mapPreloader), function(mapClassName) {
    return _h('div', {
      staticClass: "map-bg",
      class: mapClassName
    })
  })])])
}},staticRenderFns: [function (){with(this) {
  return _h('p', {
    staticClass: "help-block text-center"
  }, [_h('i', {
    staticClass: "glyphicon glyphicon-info-sign"
  }), " Press and hold on player name to delete"])
}},function (){with(this) {
  return _h('span', {
    staticClass: "glyphicon glyphicon-star"
  })
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70dccb9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 116
// module chunks = 2